import React, { useState, useEffect } from 'react'
import { ConnectOptions } from '../connect'
import Button from './Button'
import Input from './Input'
import Screen from './Screen'

import { resumeAudioContext } from '../basicSounds'
import { miscUiState } from '../globalState'

export default () => {
  const [username, setUsername] = useState(localStorage.getItem('sanscraft_username') || 'WebPlayer' + Math.floor(1000 + Math.random() * 9000))
  const [password, setPassword] = useState(localStorage.getItem('sanscraft_password') || '')
  const [rememberMe, setRememberMe] = useState(true)

  useEffect(() => {
    localStorage.setItem('sanscraft_username', username)
  }, [username])

  const handleConnect = (e?: React.FormEvent) => {
    if (e) e.preventDefault()
    if (!username.trim()) return

    resumeAudioContext()

    if (rememberMe) {
      localStorage.setItem('sanscraft_username', username)
      if (password) localStorage.setItem('sanscraft_password', password)
    } else {
      localStorage.removeItem('sanscraft_password')
    }

    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    const configuredServer = miscUiState.appConfig?.promoteServers?.[0]?.ip
    let serverTarget = configuredServer || `${protocol}//${window.location.host}/ws`
    if (!configuredServer && window.location.hostname.includes('sanscraft.top')) {
      serverTarget = `${protocol}//mc.sanscraft.top:25714/ws`
    }

    const connectOptions: ConnectOptions = {
      username: username.trim(),
      server: serverTarget,
      botVersion: '1.21',
      ...(password ? { password: password.trim() } : {})
    }

    window.dispatchEvent(new CustomEvent('connect', { detail: connectOptions }))
  }

  return (
    <Screen title="SansCraft Network — Web Client" backdrop>
      <form
        onSubmit={handleConnect}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '15px',
          width: '100%',
          maxWidth: '420px',
          margin: '0 auto',
          background: 'rgba(13, 17, 23, 0.85)',
          padding: '30px',
          borderRadius: '12px',
          border: '1px solid rgba(255, 215, 0, 0.3)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '10px' }}>
          <h1 style={{
            color: '#FFEEC4',
            fontSize: '24px',
            margin: '0 0 5px 0',
            fontFamily: 'monospace',
            textShadow: '0 2px 8px rgba(255, 215, 0, 0.5)'
          }}>
            ⚔️ SANSCRAFT NETWORK
          </h1>
          <div style={{ color: '#8B949E', fontSize: '13px', fontFamily: 'sans-serif' }}>
            Official SansCraft 1.21 Web Client
          </div>
        </div>

        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <label style={{ color: '#C9D1D9', fontSize: '13px', fontWeight: 600 }}>Username:</label>
          <Input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter your Minecraft username..."
            required
            style={{ width: '100%', padding: '8px 12px' }}
          />
        </div>

        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <label style={{ color: '#C9D1D9', fontSize: '13px', fontWeight: 600 }}>Password (if registered):</label>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Optional password for /login..."
            style={{ width: '100%', padding: '8px 12px' }}
          />
        </div>

        <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            style={{ cursor: 'pointer' }}
          />
          <label htmlFor="rememberMe" style={{ color: '#8B949E', fontSize: '12px', cursor: 'pointer' }}>
            Remember login credentials
          </label>
        </div>

        <Button
          type="submit"
          style={{
            width: '100%',
            marginTop: '10px',
            padding: '12px',
            fontSize: '16px',
            fontWeight: 'bold',
            background: 'linear-gradient(180deg, #2EA043 0%, #238636 100%)',
            color: '#FFFFFF',
            border: '1px solid #3FB950',
            borderRadius: '6px',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(46, 160, 67, 0.4)',
            transition: 'transform 0.1s ease',
          }}
        >
          ⚔️ PLAY ON SANSCRAFT
        </Button>
      </form>
    </Screen>
  )
}
